<template>
    <footer class="app-footer">
        <!-- 联系我们 -->
        <div class="contact container">
            <div class="left">
                <div class="logo"></div>
                <p>{{contactList.company}}</p>
            </div>
            <div class="right">
                <dl v-for="(item,index) in contactList.ways" :key="index">
                    <dt>
                        <i class="iconfont" :class="item.icon"></i>
                    </dt>
                    <dd>{{item.way}}</dd>
                </dl>
            </div>
        </div>
        <!-- 版权信息 -->
        <div class="copyright">
            <p class="copyright-name">版权所有：广州蜂鸟互动科技有限公司</p>
            <p class="copy">
                <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2020141763号</a>
            </p>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  setup () {
    const contactList = {
      company: '蜂鸟互动作为Soul媒体的效果广告核心代理商，为全国范围内的企业客户提供Soul广告开户和投放运营服务',
      ways: [
        { icon: 'icon-31dianhua', way: '13226446887' },
        { icon: 'icon-youxiang', way: '572322955@qq.com' },
        { icon: 'icon-qq', way: '572322955' },
        { icon: 'icon-dizhiguanli', way: '广州市天河区中山大道中433号708' }
      ]
    }

    return {
      contactList
    }
  }
}
</script>

<style lang="less" scoped>
.app-footer {
  background: #76c7c0;
  .contact {
    display: flex;
    color: #fff;
    padding: 28px 0;
    .left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 4;
      border-right: 1px solid #f2f2f2;
      padding-right: 20px;
      .logo {
        width: 190px;
        height: 66px;
        background-image: url(https://picture.fengniaohd.com/fengniao/fengniaologo.png);
        background-size: 100%;
        background-repeat: no-repeat;
      }
      p {
        text-align: center;
      }
    }
    .right {
      flex: 6;
      display: flex;
      justify-content: space-between;
      padding: 60px 0 40px 25px;
    }
    dl {
      width: 130px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      text-align: center;
    }
    dt {
      width: 50px;
      height: 50px;
      border: 1px solid #ff8c33;
      border-radius: 50%;
      text-align: center;
      line-height: 50px;
      margin-bottom: 8px;
      .iconfont {
        font-size: 26px;
        color: #ff8c33;
      }
    }
    dd {
      font-size: 12px;
    }
  }
  .copyright {
    color: #fff;
    background-color: #fff;
    font-size: 14px;
    padding: 0 0 10px 0;
    text-align: center;
    .copyright-name {
      padding-bottom: 10px;
    }
    p {
      line-height: 1;
    }
    a {
      color: #999;
      line-height: 1;
      padding: 0 10px;
    }
  }
}
</style>
